<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__channels}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.name" filterable clearable placeholder="渠道名称">
            <el-option
                    v-for="(item,index) in channelsList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.operationNames" filterable clearable placeholder="代运营机构">
            <el-option
                    v-for="(item,index) in operationNamesList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channels:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channels:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="渠道名称" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="returnStatus" label="协议确认" header-align="center" align="center" >
          <template slot-scope="scope">
	           <span v-if="scope.row.returnStatus == 1">进件返</span>
             <span v-if="scope.row.returnStatus == 2">撞库返</span>
             <span v-if="scope.row.returnStatus == 3">全流程返</span>
        	</template>
        </el-table-column>
        <el-table-column prop="repeatFlag" label="去重" header-align="center" align="center" >
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.repeatFlag === 0" type="danger" size="small">不去重</el-tag>
	            <el-tag v-if="scope.row.repeatFlag === 1" size="small">去重</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operationNames" label="代运营机构" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="callFlag" label="是否回传" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.callFlag == 0" type="danger" size="small">否</el-tag>
	          <el-tag v-if="scope.row.callFlag == 1" size="small">是</el-tag>
          </template>
        </el-table-column>
         <el-table-column prop="deduct" label="是否参与计数" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.deduct == 0" type="danger" size="small">否</el-tag>
	          <el-tag v-if="scope.row.deduct == 1" size="small">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="downloadApp" label="APP下载模式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.downloadApp == 0" type="danger" size="small">否</el-tag>
            <el-tag v-if="scope.row.downloadApp == 1" size="small">是</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="url" label="回传URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="token" label="回传token" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="checkUrl" label="撞库返URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.status === 0" type="danger" size="small">停用</el-tag>
	            <el-tag v-if="scope.row.status === 1" size="small">正常</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="chargingMode" label="渠道对接方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.chargingMode) }}
          </template>
        </el-table-column>
        <el-table-column prop="startPrice" label="起推价" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" label="渠道结算价" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channelPromPrice" label="渠道推广价" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorName" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateName" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:channels:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:channels:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './channels-add-or-update'
import { institution , getChannels } from '../../../api/list'
export default {
  mixins: [mixinViewModule],
 async created(){
 this.getModeOptions()
  
 let res = await institution()
    if(res.data.code == 0){
      console.log(res.data.data)
     this.operationNamesList = res.data.data.list.map(item => ({value:item.id,label:item.name,}))
    }else{
      this.$mesage.error(res.data.msg)
    }

    this.channelsList = []
     let res1 = await getChannels()
     if(res1.data.code == 0){
      console.log(res1.data.data)
      this.channelsList = res1.data.data.list.map(item => ({value:item.name,label:item.name}))
     }else{
      this.$message.error(res1.data.msg)
     }
    
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/channels/page',
        getDataListIsPage: true,
        exportURL: '/sys/channels/export',
        deleteURL: '/sys/channels',
        deleteIsBatch: true
      },
      channelsList:[],
      operationNamesList:[],
      dataForm: {
        id: '',
        operationNames:'',
      },
      modeList:[]
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    getDictLabel(value) {
      const dictItem = this.modeList.find(item => item.value == value);
      return dictItem ? dictItem.label : ''; 
    },
    //初始化下拉框中的选项
    async getModeOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=charging_mode`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.modeList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
  }
}
</script>
